var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',[_vm._v("Теперь ты точно будешь зареган!")]),_vm._v(" А вот твои данные: "+_vm._s(_vm.formData)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }